function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1.73333H10.6667C11.4 1.73333 12 2.33333 12 3.06666V12.4C12 13.1333 11.4 13.7333 10.6667 13.7333H1.33333C0.593333 13.7333 0 13.1333 0 12.4L0.00666667 3.06666C0.00666667 2.33333 0.593333 1.73333 1.33333 1.73333H2V0.399994H3.33333V1.73333H8.66667V0.399994H10V1.73333ZM1.3333 12.4H10.6666V5.73334H1.3333V12.4ZM10.6666 4.39999H1.3333V3.06666H10.6666V4.39999ZM9.33333 7.73333H6V11.0667H9.33333V7.73333Z",
  fill: "#121221"
});

function SvgEventPlanningTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventPlanningTiny);
export default __webpack_public_path__ + "static/media/EventPlanningTiny.8fbeda4a.svg";
export { ForwardRef as ReactComponent };